export default "__VITE_ASSET__DDgydZu$__"